import { render, staticRenderFns } from "./PlanoSafraList.vue?vue&type=template&id=219fe586&scoped=true"
import script from "./PlanoSafraList.vue?vue&type=script&lang=js"
export * from "./PlanoSafraList.vue?vue&type=script&lang=js"
import style0 from "./PlanoSafraList.vue?vue&type=style&index=0&id=219fe586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219fe586",
  null
  
)

export default component.exports